import { createGlobalStyle } from 'styled-components';
import theme from './theme';

const GlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }

  html, body, #root {
    height: 100%;
    width: 100%;
  }

  body {
    font-family: ${theme.fonts.primary};
    background-color: ${theme.colors.background.main};
    color: ${theme.colors.text.primary};
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    overflow-x: hidden;
  }

  #root {
    display: flex;
    flex-direction: column;
  }

  a {
    color: ${theme.colors.secondary};
    text-decoration: none;
    transition: color ${theme.transitions.fast};

    &:hover {
      color: ${theme.colors.tertiary};
    }
  }

  button {
    font-family: ${theme.fonts.primary};
    cursor: pointer;
    border: none;
    outline: none;
    background: transparent;
  }

  ul, ol {
    list-style: none;
  }

  input, textarea, select {
    font-family: ${theme.fonts.primary};
    border: 1px solid ${theme.colors.border.medium};
    background-color: ${theme.colors.background.input};
    color: ${theme.colors.text.primary};
    border-radius: ${theme.borderRadius.small};
    padding: ${theme.spacing.sm} ${theme.spacing.md};
    outline: none;
    transition: border-color ${theme.transitions.fast};

    &:focus {
      border-color: ${theme.colors.secondary};
    }
  }

  /* Custom scrollbar */
  ::-webkit-scrollbar {
    width: 8px;
    height: 8px;
  }

  ::-webkit-scrollbar-track {
    background: ${theme.colors.background.main};
  }

  ::-webkit-scrollbar-thumb {
    background: ${theme.colors.border.light};
    border-radius: ${theme.borderRadius.medium};
  }

  ::-webkit-scrollbar-thumb:hover {
    background: ${theme.colors.border.medium};
  }
`;

export default GlobalStyles; 